var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22,0 L22,22 L0,22 L0,0 L22,0 Z",
  id: "Vector",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.833333, 1.833333)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1469285,14.5467615 L16.0818145,14.3365246 C16.0632294,14.2692443 16.0788784,14.1971272 16.1236777,14.143601 C18.3575344,11.564551 18.8232911,7.97249578 17.3113791,4.93836018 C15.8938879,2.09253138 12.9789786,0.218066005 9.70808729,0.0135060785 L9.41460425,0 L9.09624295,0 C5.45531061,0 2.15864335,2.0671108 0.724693062,5.26117074 C-0.703189734,8.45843318 0.017219371,12.1661332 2.54838022,14.6713796 C5.0177635,17.1026639 8.73128131,17.9398556 12.0621718,16.8403118 L12.3348756,16.7457258 C12.4011839,16.7221111 12.4743468,16.7273068 12.5366524,16.760055 L12.8502389,16.9104762 C13.6505622,17.3034828 14.8071019,17.7262415 16.117752,18.1440326 C16.9220101,18.398466 17.6631929,17.5560836 17.2260824,16.8059171 C16.7513405,15.989248 16.3642311,15.2022249 16.1469285,14.5467615 Z",
  id: "Path",
  fill: "#6467EF",
  transform: "translate(9.095169, 9.095178) scale(-1, 1) translate(-9.095169, -9.095178) "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "13.1496334 6.63 13.1496334 7.82 4.93 7.82 4.93 6.63"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "11.4496335 9.71536093 11.4496335 10.9053609 4.93 10.9053609 4.93 9.71536093"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatActive);
export default ForwardRef;